import * as React from 'react';
import { findTableId, type IRoomProps, TableShape, type TableDef } from './layouts/TableShape';

import thanos from 'src/assets/tables/thanos.png';
import mystique from 'src/assets/tables/mystique.png';
import ironman from 'src/assets/tables/ironman.png';
import friends from 'src/assets/tables/friends.png';
import drdoom from 'src/assets/tables/drdoom.png';
import cptmarvel from 'src/assets/tables/cptmarvel.png';
import cptamerica from 'src/assets/tables/cptamerica.png';
import blackpanther from 'src/assets/tables/blackpanther.png';

const TABLES: TableDef[] = [
  { id: 4, x: 452, y: 80, image: cptamerica, label: 'Capt.\nAmerica' },
  { id: 6, x: 260, y: 80, image: drdoom, label: 'Dr. Doom' },
  { id: 5, x: 136, y: 170, image: ironman, label: 'Iron Man' },
  { id: 7, x: 136, y: 380, image: blackpanther, label: 'Black\nPanther' },
  { id: 8, x: 260, y: 380, image: cptmarvel, label: 'Capt.\nMarvel' },
  { id: 11, x: 452, y: 300, image: friends, label: 'F.R.I.E.N.D.S' },
  { id: 10, x: 576, y: 300, image: mystique, label: 'Mystique' },
  { id: 3, x: 576, y: 80, image: thanos, label: 'Thanos' },
];

const Room: React.FC<IRoomProps> = ({ onTableClick, activeTableId, filledTables = {}, standingTableIds }) => {
  const handleClick = (e: React.MouseEvent) => {
    const tableId = findTableId(e.target);
    if (tableId != null) onTableClick?.(tableId);
  };

  return (
    <svg className="room" onClick={handleClick} viewBox="0 0 861 630" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M410 2.5H858.5V627.5H2.49902C2.49719 536.922 2.39773 478.602 2.5 435.006V435C2.5 265.774 70.6421 157.753 155.531 91.9766C240.533 26.1128 342.473 2.5 410 2.5Z"
        className="room-wall"
      />
      <circle cx="295" cy="335" r="32.5" className="room-wall" />
      <circle cx="865" cy="235" r="32.5" className="room-wall" />
      {TABLES.map(t => (
        <TableShape
          key={t.id}
          data-active={activeTableId === t.id}
          data-filled={!!filledTables[t.id]}
          data-empty={!filledTables[t.id]}
          user={filledTables[t.id]?.user}
          standing={standingTableIds?.has(t.id)}
          {...t}
        />
      ))}
    </svg>
  );
};

export default Room;
